import { ChangeEvent, useCallback } from 'react';

import { TextField, TextFieldProps } from '@material-ui/core';

import { FormFieldProps, useFormField } from '../../context';

export type DescriptionFormFieldProps = Omit<TextFieldProps, 'value'> &
  FormFieldProps<string> & {
    loading?: boolean;
  };

export const DescriptionFormField = ({
  field = 'description',
  initialValue = '',
  onChange,
  loading,
  ...props
}: DescriptionFormFieldProps) => {
  const { value, setValue } = useFormField(field, initialValue);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
      onChange?.(e);
    },
    [onChange, setValue],
  );

  return (
    <TextField
      fullWidth
      multiline
      minRows={4}
      maxRows={4}
      value={value ?? ''}
      onChange={handleChange}
      label="Description"
      margin="dense"
      variant="outlined"
      InputLabelProps={{ shrink: true, ...props.InputLabelProps }}
      disabled={loading}
      {...props}
    />
  );
};
